import React, {useEffect, useRef, useState} from 'react';
import CustomTable from '../../../components/customTable/CustomTable';
import {getLanguage, t} from 'react-switch-lang';
import {
  getAllFinancialPerformances,
  createFinancialPerformance,
  deleteFinancialPerformance,
  updateFinancialPerformance,
} from '../../../services/FinancialPerformances/financialPerformances';
import Toast from '../../../components/toast/Toast';
import Prompt from '../../../components/prompt/prompt';
import SearchBox from '../../../components/searchBox/SearchBox';
import { validNumberRegex, validNameandNumberEngMneRegex } from '../../../utils/const';
import Swal from "sweetalert2";
import AddIcon from '../Metodologies/plus.png';
import {useUserContext} from '../../../contexts/UserContext';
import roles from '../../../utils/roles';

const FinancialPerformances = () => {
  const [financialPerformances, setFinancialPerformances] = useState([]);
  const [query, setQuery] = useState();
  const user = useUserContext()
  const canEdit = user?.authorities?.some((role) =>
    [roles.role_super_admin, roles.role_admin, roles.role_technological].includes(role)
  );
  const canAddAndDelete = user?.authorities?.includes(roles.role_super_admin)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const {data} = await getAllFinancialPerformances();
        setFinancialPerformances(data);
      } catch (err) {}
    };
    fetchData();
  }, []);

  const columns = [
    {
      dataIndex: 'name',
      title: t('common.name'),
      editable: true,
      placeholder:`${t('common.placeholder.name')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        // {pattern: validNameandNumberEngMneRegex, message: t('message.mustBeNumber')},
        {whitespace: true, message: t('message.fieldNotValid')},
      ],
    },
    {
      dataIndex: 'nameEn',
      title: t('common.nameEn'),
      editable: true,
      placeholder:`${t('common.placeholder.nameEn')}`,
      rules: [
        {required: true, message: t('message.fieldRequired')},
        {min: 3, message: t('message.min', {min: 3})},
        {max: 50, message: t('message.max', {max: 50})},
        // {pattern: validNameandNumberEngMneRegex, message: t('message.mustBeNumber')},
        {whitespace: true, message: t('message.fieldNotValid')},
      ],
    },
    {
      dataIndex: 'minValue',
      title: t('financialPerformances.label.minValue'),
      editable: true,
      placeholder: `${t('common.insert')} ${t('financialPerformances.placeholder.minValue').toLowerCase()}`,
      inputType: "number",
      max: 100000000000000,
      rules: [
        {
          pattern: validNumberRegex,
          message: t('message.negativeNumber'),
        },
      ],
    },
    {
      dataIndex: 'maxValue',
      title: t('financialPerformances.label.maxValue'),
      editable: true,
      placeholder: `${t('common.insert')} ${t('financialPerformances.placeholder.maxValue').toLowerCase()}`,
      inputType: "number",
      max: 100000000000000,
      rules: [
        {
          pattern: validNumberRegex,
          message: t('message.negativeNumber'),
        },
      ],
    },
  ];

  const onUpdate = async (data, editingRecord, form) => {
    data.id = editingRecord.id;
    // data.nameEn = data.nameEn.trim();
    // data.name = data.name.trim();
    try {
      const response = await updateFinancialPerformance(data);
      if (response.status === 200) {
        Toast.fire({
          title: t('message.updateSuccess2', {entity: t('financialPerformances.financialPerformance')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('financialPerformances.financialPerformancesExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('financialPerformances.financialPerformancesExists')],
          },
        ]);
      } else if (err.response.data.code === "min_max_compare"){
        form.setFields([
          {
            name: 'minValue',
            errors: [t('financialPerformances.minMaxCompare')],
          },
        ]);
        form.setFields([
          {
            name: 'maxValue',
            errors: [t('financialPerformances.minMaxCompare')],
          },
        ]);
      } else if (err.response.data.code === "min_max_required") {
        form.setFields([
          {
            name: 'minValue',
            errors: [t('financialPerformances.oneFieldRequired')],
          },
        ]);
        form.setFields([
          {
            name: 'maxValue',
            errors: [t('financialPerformances.oneFieldRequired')],
          },
        ]);
      } else if (err.response.data.code === "min_max_zero") {
        form.setFields([
          {
            name: 'minValue',
            errors: [t('financialPerformances.cannotBeZero')],
          },
        ]);
        form.setFields([
          {
            name: 'maxValue',
            errors: [t('financialPerformances.cannotBeZero')],
          },
        ]);
      }
    }
  };

  const onCreate = async (data, form) => {
    if (!canAddAndDelete) {
      return {status: 403};
    }

    // data.nameEn = data.nameEn.trim();
    // data.name = data.name.trim();
    try {
      const response = await createFinancialPerformance(data);
      if (response.status === 201) {
        Toast.fire({
          title: t('message.addSuccess2', {entity: t('financialPerformances.financialPerformance')}),
          icon: 'success',
        });
      }
      return response;
    } catch (err) {
      if (err.response.data.detail === "name") {
        form.setFields([
          {
            name: 'name',
            errors: [t('financialPerformances.financialPerformancesExists')],
          },
        ]);
      } else if (err.response.data.detail === "name_en") {
        form.setFields([
          {
            name: 'nameEn',
            errors: [t('financialPerformances.financialPerformancesExists')],
          },
        ]);
      } else if (err.response.data.code === "min_max_compare"){
        form.setFields([
          {
            name: 'minValue',
            errors: [t('financialPerformances.minMaxCompare')],
          },
        ]);
        form.setFields([
          {
            name: 'maxValue',
            errors: [t('financialPerformances.minMaxCompare')],
          },
        ]);
      } else if (err.response.data.code === "min_max_required") {
        form.setFields([
          {
            name: 'minValue',
            errors: [t('financialPerformances.oneFieldRequired')],
          },
        ]);
        form.setFields([
          {
            name: 'maxValue',
            errors: [t('financialPerformances.oneFieldRequired')],
          },
        ]);
      } else if (err.response.data.code === "min_max_zero") {
        form.setFields([
          {
            name: 'minValue',
            errors: [t('financialPerformances.cannotBeZero')],
          },
        ]);
        form.setFields([
          {
            name: 'maxValue',
            errors: [t('financialPerformances.cannotBeZero')],
          },
        ]);
      }
    }
  };

  const onDelete = async (record) => {
    if (!canAddAndDelete) {
      return {status: 403};
    }

    let response;
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('financialPerformances.financialPerformance'),
        text: t('question.delete', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
        confirmButtonText: t('common.delete2').toUpperCase(),
        cancelButtonText: t('common.cancel').toUpperCase(),
        preConfirm: async () => {
          try {
            response = await deleteFinancialPerformance(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('message.deleteSuccess2', {entity: t('financialPerformances.financialPerformance')}),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
            Swal.fire({
              text: t('message.deleteFailed', {entity: getLanguage() === "eng" ? record.nameEn : record.name}),
              icon: 'error',
            });
          }
        },
      });
    });
  };

  const addButton = useRef();

  return (
    <div className="financial-performances administration-template">
      <div className="w-100 d-flex justify-content-between mb-4">
        <div className="search">
          <SearchBox
            placeholder={t('financialPerformances.searchFinancialPerformances')}
            setQuery={setQuery}
          />
        </div>
        {canAddAndDelete && <div className="button-add">
          <button className="btn btn-primary btn-strong" ref={addButton}>
            <img src={AddIcon} alt="" />
            <p> {t('common.add')}</p>
          </button>
        </div>}
      </div>
      <CustomTable
        api="/financial-performances"
        query={query}
        queryEn={query}
        sort={"id"}
        columns={columns}
        methods={{onUpdate, onDelete, onCreate}}
        addButtonRef={addButton}
        canEdit={canEdit}
        hideDeleteAndDeactivation={!canAddAndDelete}
      />
    </div>
  );
};

export default FinancialPerformances;
